<hw-page-header header="term.di-03.header" class="page-header">
  <div class="content float-right">
    <button
      class="button"
      type="button"
      nz-button
      nzType="secondary"
      [routerLink]="['/dictionaries/edit', dictionary?.id]">
      {{ 'term.di-03.button.edit' | translate }}
    </button>
  </div>
</hw-page-header>

<nz-content class="main" *ngIf="dictionary">
  <hw-form-row>
    <hw-form-item *hwFormCol label="term.di-03.id">
      {{ dictionary.id }}
    </hw-form-item>
  </hw-form-row>
  <hw-form-row>
    <hw-form-item *hwFormCol label="term.di-03.title">
      {{ dictionary.title | localName }}
    </hw-form-item>
  </hw-form-row>
  <hw-form-row>
    <hw-form-item *hwFormCol label="term.di-03.name">
      {{ dictionary.names | localName }}
    </hw-form-item>
  </hw-form-row>

  <hw-table *ngIf="versions" header="term.di-03.versions.title">
    <div headerContent>
      <button class="button" (click)="addVersion(dictionary.id)" nz-button nzType="primary">
        {{ 'term.di-03.versions.btn.add-version' | translate }}
      </button>
      <button class="button" [disabled]="!twoVersionsSelected" (click)="compareVersions()" nz-button nzType="secondary">
        {{ 'Compare versions' | translate }}
      </button>
    </div>
    <nz-table #nzTable [nzData]="versions" nzSize="small" nzHideOnSinglePage="true" nzShowSizeChanger="false">
      <thead>
        <tr>
          <th>{{ 'term.di-03.versions.number' | translate }}</th>
          <th>{{ 'term.di-03.versions.valid-from' | translate }}</th>
          <th>{{ 'term.di-03.versions.valid-to' | translate }}</th>
          <th>{{ 'term.di-03.versions.status' | translate }}</th>
          <th>{{ 'term.di-03.versions.actions' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of nzTable.data">
          <td>
            <a [routerLink]="['/dictionaries', dictionary.id, 'versions', 'view', row.version]">{{ row.version }}</a>
          </td>
          <td>{{ row.valid.lower | localDate }}</td>
          <td>{{ row.valid.upper | localDate }}</td>
          <td>{{ row.status }}</td>
          <td>
            <a (click)="copyVersion(dictionary.id, row.version)">{{ 'term.di-03.versions.action.copy' | translate }}</a>
            <ng-container *ngIf="row.status !== 'final'">
              <nz-divider nzType="vertical"></nz-divider>
              <a (click)="publishVersion(dictionary.id, row.version)">{{
                'term.di-03.versions.action.publish' | translate
              }}</a>
              <nz-divider nzType="vertical"></nz-divider>
              <a (click)="deleteVersion(dictionary.id, row.version)">{{
                'term.di-03.versions.action.delete' | translate
              }}</a>
            </ng-container>
          </td>
          <td
            nzShowCheckbox
            [(nzChecked)]="row.checked"
            [nzDisabled]="row.disabled"
            (nzCheckedChange)="checkboxesRefreshed()"></td>
        </tr>
      </tbody>
    </nz-table>
  </hw-table>
</nz-content>
